import { OrderByEnum } from '@shared/models/common/orderby.enum';
import { MesEtablissementSearcholonneEnum } from '@features/compte/mes-etablissements/features/mes-etablissements-table/models/mes-etablissements-search-colonne-enum';

export class MesEtablissementSearchForm {
  constructor(
    public creteriaSearch: string = '',
    public page: number = 0,
    public pageSize: number = 5,
    public nbElement?: number,

    public orderBy: OrderByEnum = OrderByEnum.ASC,
    public orderByColumn: MesEtablissementSearcholonneEnum = MesEtablissementSearcholonneEnum.RAISONSOCIALE,
  ) {}
}
